import React from "react";
import "./VideoBackground.css"; // Custom styling (optional)
import PulsatingArrow from "./PulsatingArrow"; // Import the new component
import LazyVideo from "./LazyVideo";

const VideoBackground = () => {
  return (
    <div className="container-2">
      <div className="video-container">
        <LazyVideo
          cloudinarySrc="https://res.cloudinary.com/donwh3eei/video/upload/f_auto,q_auto/videos/output_ztsrqh"
          poster="https://res.cloudinary.com/donwh3eei/image/upload/v1752962684/videos/video-placeholder_rcpqnh.jpg"
          className="video"
          delay={800} // Load 800ms after page is ready
        />
      </div>
      {/* <div className="content">
        <p className="pb-8">
          <span className="highlight text-4xl leading-relaxed">
          Porsche - Meisterwerkstatt für Restauration & Motorentechnik
          </span>{" "}
        </p> */}
      {/* <div className="quote-container">
          <p style={{ padding: 20 }}>
            "Das letzte Auto, das gebaut werden wird, wird ein Sportwagen sein."{" "}
          </p>
          <p style={{ marginBottom: 20 }}>— Ferdinand Porsche</p>
        </div> */}
      {/* <PulsatingArrow /> */}
      {/* </div> */}
    </div>
  );
};

export default VideoBackground;
